import { put, takeLatest, call } from 'redux-saga/effects';
import axios from 'axios';
import Swal from 'sweetalert2';

function* fetchPartner(action) {

    const { history } = action.payload;
    console.log('in fetch', action.payload);
    const response = yield axios.get(`/api/referral-partners/${action.payload.code}`);
    if (!response.data) {
        Swal.fire({
            title: `Please enter a valid referral partner code!`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK',
          });
    } else {
        yield put({ type: 'SET_PARTNER', payload: response.data });
        yield call(history.push, `/referralform/${response.data.id}`);
    }
}

function* partnerSaga() {
    yield takeLatest('FETCH_PARTNER', fetchPartner);
}

export default partnerSaga;